module.exports = __webpack_public_path__ + "img/icon-close.4a87f130.svg";